var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8317 6.8907C17.4403 8.22736 15.3961 7.57392 13.2316 6.8816C10.9029 6.13718 8.49307 5.36463 4.58413 6.88988C4.4301 6.95 4.29768 7.05643 4.20451 7.19502C4.11133 7.33361 4.0618 7.49779 4.06251 7.66573V26.69C4.06251 26.9093 4.14811 27.1197 4.30048 27.2748C4.45286 27.43 4.65952 27.5171 4.87501 27.5171C5.0905 27.5171 5.29716 27.43 5.44953 27.2748C5.6019 27.1197 5.68751 26.9093 5.68751 26.69V19.0124C7.98165 18.1697 10.5041 18.2418 12.7481 19.2143C16.0631 20.383 18.7866 20.383 21.4183 19.187C21.5686 19.1238 21.6977 19.0175 21.7899 18.8811C21.882 18.7448 21.9333 18.5841 21.9375 18.4186V7.66573C21.9362 7.53172 21.9032 7.4 21.8414 7.28168C21.7796 7.16336 21.6907 7.06192 21.5823 6.98592C21.4738 6.90993 21.349 6.8616 21.2184 6.84503C21.0878 6.82846 20.9551 6.84412 20.8317 6.8907Z",
    fill: "#FD4438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveFlag);
export default __webpack_public_path__ + "static/media/driveFlag.9063a899af00ac0fbf8614f025a70d3d.svg";
export { ForwardRef as ReactComponent };